import { Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';

export default class InserirTag extends Plugin {
    public static get pluginName() {
        return 'InserirTag' as const;
    }

    public init(): void {
        const editor = this.editor;

        editor.ui.componentFactory.add( 'inserirTag', locale => {
            const button = new ButtonView( locale );

            button.set( {
                label: '{ }',
                withText: true,
                tooltip: 'Inserir campo dinâmico',
            } );

            button.on( 'execute', () => {
                editor.fire( 'inserirTag' );
            } );

            return button;
        } );
    }
}
